<template>
	<div class="rowDetail">
		<div class="rowDetail-subtitle">Длина ряда: {{ rowWidth }} мм</div>
		<div class="rowDetail-title">Параметры ряда</div>
		<ul class="rowDetail-params">
			<!-- <li>Нагрузка, кг: {{ data.capacity }}</li> -->
			<li>Высота, мм: {{ data.height }}</li>
			<li>Глубина, мм: {{ data.depth }}</li>
			<!-- <li>Длина, мм: {{ data.width }}</li>
			<li>Ярусов: {{ data.count }}</li> -->
		</ul>
		<button @click="$emit('edit')">Изменить</button>
		<div class="rowDetail-title" v-if="canSideScreen">Боковые экраны ряда
			<Info>У конструкций на общих стойках
				боковые экраны могут быть выбраны
				только у крайних стеллажей
				справа и слева
			</Info>
		</div>
		<ul class="rowDetail-params" v-if="canSideScreen">
			<li v-if="data.accessories.side_screen">Есть, {{ data.accessories.side_screen_count }} комп.</li>
			<li v-else>Нет</li>
		</ul>
		<button @click="$emit('editSideScreens')" v-if="canSideScreen">Изменить</button>
		<div class="rowDetail-subtitle">Секций: {{ sections.length }}</div>
		<div class="rowDetail-priceLabel">стоимость ряда:</div>
		<div class="rowDetail-price">{{ price }} ₽</div>
		<a href="#accessories">Детализация комплектующих</a>
		<div class="rowDetail-hint">Обратите внимание: изображение стеллажей — схематичное</div>
	</div>
</template>

<script>
	import Info from './Info';

	export default {
		name: 'RowDetail',
		components: {
			Info
		},
		props: {
			data: Object,
			rowWidth: Number,
			sections: Array,
			price: {
				type: [Number, String],
				default: 0,
			},
			rackWidth: {
				type: Number,
				default: 6,
			},
		},
		computed: {
			additionalSections() {
				return this.sections.length - 1;
			},
			canSideScreen() {
				return !this.data.separate && this.checkDepthBackScreen(this.data.depth)
			},
		},
		methods: {
			checkDepthBackScreen(depth) {
				return [600, 800, 1000].includes(+depth);
			},
		},
	}
</script>

<style>
	.rowDetail {
		padding: 16px 24px 32px;
		width: 264px;
		font-size: 14px;
		background: #F6F6F6;
	}
	.rowDetail a {
		text-decoration: none;
		color: #0A53B3;
	}
	.rowDetail-title {
		margin: 24px 0 8px;
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
		text-transform: uppercase;
		color: #A7A7A7;
	}
	.rowDetail-subtitle {
		margin-bottom: 32px;
		font-family: Oswald, Roboto, sans-serif;
		font-weight: 500;
		line-height: 21px;
		text-transform: uppercase;
		color: #A7A7A7;
	}
	.rowDetail-subtitle:not(:first-child) {
		margin-top: 66px;
	}
	.rowDetail-params {
		margin: 8px 0 16px;
		padding: 0;
		list-style: none;
		font-weight: bold;
	}
	.rowDetail-params > li {
		margin: 8px 0;
	}
	.rowDetail-priceLabel {
		font-weight: bold;
		font-size: 18px;
		text-transform: uppercase;
	}
	.rowDetail-price {
		margin-bottom: 32px;
		font-weight: bold;
		font-size: 30px;
	}
	.rowDetail-hint {
		margin-top: 40px;
		color: #A7A7A7;
	}
</style>
